<template>
  <div :class="subNavOuterClasses">
    <div :class="subNavInnerClasses">

      <div class="sub-nav-head">
        <cvt-floating-breadcrumb
          :mode="'LIGHT'"
          :active-menu="activeMenu"
          :menus="breadcrumbMenus"
          :hide-back-btn="false"
          :hide-next-btn="false"
          @menuChanged="(eventData) => onBreadCrumbSelectionChange(eventData)"
        />
      </div>
      
      <div :class="subNavContentClasses">
        <slot></slot>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'SubNavBar',
  props: {
    activeMenu: {
      type: String,
      default: 'design',
    },
  },
  data() {
    return {
      popupId: undefined,
      currentMenuId: this.activeMenu,
      breadcrumbMenus: [
        {
          id: 'design',
          title: 'Design',
          completed: false,
          disabled: false,
          action: this.designToggle,
        },
        {
          id: 'settings',
          title: 'Settings',
          completed: false,
          disabled: false,
          action: this.settingToggle,
        },
        {
          id: 'publish',
          title: 'Publish',
          completed: false,
          disabled: false,
          action: this.publishToggle,
        },
      ],
    }
  },

  computed: {
    subNavOuterClasses() {
      return {
        'sub-nav-container': true,
        'design-page': this.currentMenuId === 'design',
        'settings-page': this.currentMenuId === 'settings',
        'publish-page': this.currentMenuId === 'publish',
      }
    },
    subNavInnerClasses() {
      return {
        'sub-nav': true,
      }
    },
    subNavContentClasses() {
      return {
        'sub-nav-content': true,
        'design-page-2': this.currentMenuId === 'design',
        'settings-page-2': this.currentMenuId === 'settings',
      }
    },
  },
  mounted() {
    const { popupId } = this.$route.params
    this.popupId = popupId
  },
  methods: {
    designToggle() {
      this.$router.push({
        path: 'design',
      })
    },
    settingToggle() {
      this.$router.push({
        path: 'settings',
      })
    },
    publishToggle() {
      this.$router.push({
        path: 'publish',
      })
    },
    onBreadCrumbSelectionChange(eventData) {
      if (eventData && eventData.action) {
        eventData.action()
        this.currentMenuId = eventData.id
      }
    },
  },
}
</script>

<style scoped lang="scss">

.sub-nav-container {
  position: absolute;
  padding-top: 80px;
  width: 100%;
  z-index: 0;

  &.publish-page {
    & .sub-nav {
        min-height: 55vw;
      grid-template-columns: 82px 1fr 82px;
    }
  }

  .sub-nav {
    display: grid;
    grid-template-rows: 44px 1fr 25px;
    grid-template-columns: 82px 1fr 272px;
    gap: 45px 28px;

    &-publish {
      grid-template-rows: 44px 1fr;
      grid-template-columns: 1fr 9fr 1fr;
    }

    &-head {
      grid-row: 1;
      grid-column: 2/3;
      background-color: white;
      transform: scale(1) !important;
      border-radius: 8px;
    }

    &-content {
      grid-row: 2;
      grid-column: 2/3;

      &.design-page-2 {
        background: #7d7f89;
      }

      &.settings-page-2 {
        background: #ffffff;
        border-radius: 8px;
      }
    }
  }

  &.design-page {
    background: #ECECEC;
  }

  &.settings-page,
  &.publish-page {
    background: #BCC2CB;
  }

}
</style>
